export const mappingExpTypeToLabel: Record<any, string> = {
  fb_exploration: "Firebase exploration",
};

export const mappingLabelToExpType: Record<any, string> = {
  "Firebase exploration": "fb_exploration",
};
